export default __webpack_public_path__ + "static/media/flare_03.305a62b0.png";